import { datasource } from "./datasource";

export const jobServiceDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("job_service", {
    model: {
      id: "id",
      fields: {
        id: {
          type: "string",
        },
        user_id: {
          type: "string",
        },
        name: {
          type: "string",
        },
        price: {
          type: "number",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
        sort_order: {
          type: "number",
        },
        sku: {
          type: "string",
        },
      },
    },
  });
